var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#2563EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17V3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6 9 6-6 6 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21h14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileBlueIcon);
export default __webpack_public_path__ + "static/media/upload-file-blue-icon.1b8051f1c910ccfe8989c717450100f4.svg";
export { ForwardRef as ReactComponent };